import { PropsWithChildren, useState, type ReactElement } from 'react';
import { ArrowDown2, ArrowUp2 } from '@/components/icons';

type Props = {
    compareAgainst: number;
    maximumItems?: number;
} & PropsWithChildren;

function BlockWithShowMore({ compareAgainst, maximumItems = 8, children }: Props): ReactElement {
    const [showAll, setShowAll] = useState(false);

    return (
        <>
            <div
                className={`flex flex-wrap gap-2 ${
                    !showAll && compareAgainst > maximumItems
                        ? 'max-h-[88px] overflow-hidden'
                        : 'max-h-[300px] overflow-y-auto'
                }`}
            >
                {children}
            </div>

            {compareAgainst > maximumItems && (
                <button
                    onClick={() => setShowAll(!showAll)}
                    className="mt-2 flex w-full items-center justify-center gap-1 text-sm text-slate-600 hover:text-slate-900"
                >
                    {showAll ? 'Mostrar menos' : 'Mostrar mais'}
                    {showAll ? <ArrowUp2 className="size-4" /> : <ArrowDown2 className="size-4" />}
                </button>
            )}
        </>
    );
}

export default BlockWithShowMore;
